import { gql } from '@apollo/client';

export const GET_ACTIVE_FINAL_EXAM = gql`
  query GetActiveFinalExam {
    getActiveFinalExam {
      id
      userId
      tags
      userQuestions {
        questionId
        question {
          id
          prompt
          options {
            desc
            isAnswer
          }
          explanation
          tag
        }
        selectedOption {
          desc
          isAnswer
        }
      }
      isCompleted
      completedAt
      createdAt
      updatedAt
    }
  }
`;
